<section class="section" id="form-landing-fru" [ngClass]="officeStatus?.answer ? '' : 'zero-padding'">
	<div class="container">
		<h1 class="has-text-centered" [innerHTML]="headerText" style="color: #fff;"></h1>

		<div class="columns is-centered">
			<div class="column">
				<div class="secure_form"><span><i class="fa fa-lock fa-lg"></i> Secure Form</span></div>
				<h2 class="has-text-centered has-text-grey-dark has-text-weight-semibold">
					Choose loan type
				</h2>
				
				<div class="buttons is-centered">
					<button (click)="redirectForm('refinance')" class="button icon-button icon-button-refinance">Refinance</button>
					<button (click)="redirectForm('purchase')" class="button icon-button icon-button-purchase">Purchase</button>
					<button (click)="redirectForm('refinance', 'heloc', 'homeequity')" class="button icon-button icon-button-heloc">Home Equity</button>
					<button (click)="redirectForm('refinance', 'cashout')" class="button icon-button icon-button-cash-out">Cash Out</button>
					<button (click)="redirectForm('refinance', 'homeimprovement')" class="button icon-button icon-button-home-improvement">Home Improvement</button>
				</div>
				<p   style="text-align: right">
					<a (click)="redirectForm('refinance', 'cashout', 'yes')" class="header-disclosure-link" style="color: #1e647f">
						Max Cash Out
					</a>
				</p>
			</div>
		</div>
		<p style="text-align: center">
			<a (click)="adDisclosurePopup()" class="header-disclosure-link" style="color: #1e647f">
				* Advertising and Licensing Disclosures
			</a>
		</p>
	</div>
  	<div *ngIf="showTop10" id="top10Container">
		<div id="top10">
			<app-lender-listings
				[initialState]="state"
				[officeStatus]="officeStatus"
			>
			</app-lender-listings>
		</div>
  	</div>
</section>
